import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, InputAdornment } from '@mui/material';
import { NumberTextField } from 'modules/common';
import { useTranslation } from 'react-i18next';

export default function ExpressPricesDialog({
    open,
    expressPriceValue,
    handleChange,
    onAdd,
    handleClose,
}) {
    const { t } = useTranslation()
    return (
        <Dialog
            open={open}
            onClose={e => e.preventDefault()}
            aria-labelledby="express-price-title"
            aria-describedby="express-price-description"
        >
            <DialogTitle id="express-price-title">
                {t("Add express price")}
            </DialogTitle>
            <Divider />
            <DialogContent>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <NumberTextField
                        name="count"
                        label={t("CountShoes", { count: !!expressPriceValue?.count ? `(${expressPriceValue?.count})` : "(--)" })}
                        placeholder={t("Count")}
                        value={expressPriceValue?.count ?? ''}
                        onChange={handleChange}
                        size="small"
                        sx={{ mx: 10 }}
                        InputProps={{
                            endAdornment: <InputAdornment position="end"> <img src="/images/smart-shoe.svg" width={25} height={25} alt='shoe' /></InputAdornment>,
                        }}
                    />
                    <NumberTextField
                        InputProps={{
                            endAdornment: <InputAdornment position="end">{t("Riyal")}</InputAdornment>,
                        }}
                        name="price"
                        label={t("Price")}
                        value={expressPriceValue?.price ?? ''}
                        onChange={handleChange}
                        size="small"
                        sx={{ mx: 10 }}
                    />
                </Box>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button sx={{ textTransform: "none" }} variant="contained" onClick={handleClose}>{t("Close")}</Button>
                <Button sx={{ textTransform: "none" }} variant="contained" onClick={onAdd}>
                    {t("Add")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}